'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dPolicy$002dCode$0024 from "./presto.types$-Policy-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$11() {
  this.bec = null;
  this.bea = null;
  this.beb = false;
  this.be8 = null;
  this.be9 = false;
  this.bed = false;
  this.bee = false;
  this.bec = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$11 as $c_Lpresto_PrestoRouter$$anon$11 };
$p = $c_Lpresto_PrestoRouter$$anon$11.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$11;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$11() {
}
export { $h_Lpresto_PrestoRouter$$anon$11 as $h_Lpresto_PrestoRouter$$anon$11 };
$h_Lpresto_PrestoRouter$$anon$11.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bec;
});
$p.t = (function() {
  if ((!this.beb)) {
    this.bea = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.beb = true;
  }
  return this.bea;
});
$p.ae = (function() {
  if ((!this.be9)) {
    this.be8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPolicy$002dCode$0024.$m_Lpresto_types$PolicyCode$().ady(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.be9 = true;
  }
  return this.be8;
});
$p.w = (function() {
  if ((!this.bee)) {
    this.bed = false;
    this.bee = true;
  }
  return this.bed;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$11, "presto.PrestoRouter$$anon$11", ({
  Nx: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$11 as $d_Lpresto_PrestoRouter$$anon$11 };
//# sourceMappingURL=presto.-Presto-Router$$anon$11.js.map
